import {resolveBackground} from '#core/utils/color-utils.js';
import {borderStyle, icon} from '#core/utils/style-utils.js';

import {generatePrimaryButton} from '#core/application/modules/tiles/button/index.js';
import {generateBetBaseInfo} from '#core/application/modules/tiles/bet-base-info/index.js';
import {CLOSE_BUTTON_TYPES, generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

export function matchAccaSlipFactory(PALETTE) {
    return {
        ...matchAccaSlipViewFactory(PALETTE),
        ...matchAccaSlipSelectionFactory(PALETTE),
        ...matchAccaSlipOnboardingFactory(PALETTE),
    };
}

function matchAccaSlipViewFactory(PALETTE) {
    const {FONT} = PALETTE;

    const headerCounterButtonStyles = {
        ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_COUNTER_BUTTON_BG),
        borderColor: PALETTE.MATCH_ACCA_SLIP_COUNTER_BUTTON_BG,
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: PALETTE.MATCH_ACCA_SLIP_COUNTER_BUTTON_SHADOW,
        height: 40,
        width: 40,
        minHeight: 40,
        minWidth: 40,
        fontSize: 20,
        fontWeight: FONT.WEIGHT_BOLD,
        ...PALETTE.MATCH_ACCA_SLIP_COUNTER_BUTTON_TEXT,
    };
    const headerLabelStyles = {
        fontSize: FONT.SIZE_LARGE,
        fontWeight: FONT.WEIGHT_BOLD,
        textTransform: 'uppercase',
        ...PALETTE.MATCH_ACCA_SLIP_HEADER_LABEL_TEXT,
    };
    const headerEventNameStyles = {
        fontSize: FONT.SIZE_SMALL,
        ...PALETTE.MATCH_ACCA_SLIP_HEADER_EVENT_NAME_TEXT,
    };

    const oddsLabelBaseStyles = {
        fontSize: 11,
    };
    const oddsValueBaseStyles = {
        fontSize: FONT.SIZE_MEDIUM,
        fontWeight: FONT.WEIGHT_BOLD,
    };

    const MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON = generatePrimaryButton(PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON);

    return {
        MatchAccaSlipView: {
            dialogSlip: {
                dialog: {
                    background: resolveBackground(PALETTE.MATCH_ACCA_SLIP_BG),
                    header: {
                        container: {
                            borderStyle: {
                                borderStyle: 'none',
                            },
                            style: {
                                height: '40px',
                                margin: '6px 0',
                            },
                        },
                    },
                    closeButtonContainer: {
                        style: {
                            borderRadius: '50%',
                            height: 'initial',
                            padding: 4,
                            width: 'initial',
                            top: 'initial',
                            bottom: '100%',
                        },
                    },
                    closeButton: generateCloseButton(
                        PALETTE.MATCH_ACCA_SLIP_DIALOG_CLOSE_BUTTON,
                        CLOSE_BUTTON_TYPES.CIRCULAR
                    ),
                },
                selectionCountContainer: {
                    style: headerCounterButtonStyles,
                },
                headerLabel: {
                    style: headerLabelStyles,
                },
                eventLabel: {
                    style: headerEventNameStyles,
                },
            },
            expandableSlip: {
                container: {
                    style: {
                        ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_BG),
                        borderRadius: 4,
                    },
                },
                selectionCountContainer: {
                    style: headerCounterButtonStyles,
                },
                headerLabel: {
                    style: headerLabelStyles,
                },
                eventLabel: {
                    style: headerEventNameStyles,
                },
                oddsLabel: {
                    style: {
                        padding: '4px 0 0',
                        ...oddsLabelBaseStyles,
                        ...PALETTE.MATCH_ACCA_SLIP_HEADER_ODDS_LABEL_TEXT,
                    },
                },
                oddsValue: {
                    style: {
                        ...oddsValueBaseStyles,
                        ...PALETTE.MATCH_ACCA_SLIP_HEADER_ODDS_VALUE_TEXT,
                    },
                },
                headerToggleButton: {
                    style: {
                        base: {
                            padding: 8,
                        },
                    },
                },
            },
            toggleButtonIcon: icon(PALETTE.MATCH_ACCA_SLIP_HEADER_ROTATION_ICON_COLOR),
            removeAll: {
                button: {
                    style: {
                        base: {
                            fontSize: FONT.SIZE_MEDIUM,
                            margin: '0 8px 0 0',
                            ...PALETTE.MATCH_ACCA_SLIP_REMOVE_ALL_BUTTON_TEXT,
                        },
                    },
                },
            },
            errors: {
                message: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_BG),
                            ...borderStyle(
                                PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_BORDER_RADIUS,
                                PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_BORDER_COLOR,
                                1
                            ),
                        },
                    },
                    iconArea: {
                        style: {
                            width: '0px',
                        },
                    },
                    icon: icon(PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_ICON_COLOR, 'exclamation-mark'),
                    infoContainer: {
                        style: {
                            padding: 7,
                        },
                    },
                    infoHeader: {
                        style: {
                            fontSize: FONT.SIZE_MEDIUM,
                            ...PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_TEXT,
                        },
                    },
                    infoMessage: {
                        style: {
                            fontSize: FONT.SIZE_MEDIUM,
                            ...PALETTE.MATCH_ACCA_SLIP_ERROR_NOTIFICATION.ERROR_TEXT,
                        },
                    },
                },
            },
            addToBetslipButton: {
                button: {
                    style: {
                        base: {
                            ...MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.style.base,
                            whiteSpace: 'nowrap',
                            padding: '0 8px',
                            borderRadius: `0 ${PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.PRIMARY_BUTTON_BORDER_RADIUS}px ${PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.PRIMARY_BUTTON_BORDER_RADIUS}px 0`,
                        },
                        // disabled: PRIMARY_BUTTON.style.disabled, - until better times MOJ-11246
                        disabled: {
                            opacity: 0.5,
                        },
                    },
                },
                // also should be split in MOJ-11246
                container: {
                    style: {
                        borderRadius: PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.PRIMARY_BUTTON_BORDER_RADIUS,
                        borderColor: PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BORDER_COLOR,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        boxSizing: 'border-box',
                        _mobile_minHeight: '40px',
                    },
                },
                odds: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_ODDS_CONTAINER_BG),
                            borderRadius: `${PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.PRIMARY_BUTTON_BORDER_RADIUS}px 0 0 ${PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_BUTTON.PRIMARY_BUTTON_BORDER_RADIUS}px`,
                        },
                    },
                    label: {
                        style: {
                            ...oddsLabelBaseStyles,
                            ...PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_ODDS_LABEL_TEXT,
                        },
                    },
                    value: {
                        style: {
                            ...oddsValueBaseStyles,
                            ...PALETTE.MATCH_ACCA_SLIP_ADD_TO_BETSLIP_ODDS_VALUE_TEXT,
                        },
                    },
                },
            },
        },
    };
}

function matchAccaSlipSelectionFactory(PALETTE) {
    const selectionBaseInfo = generateBetBaseInfo(PALETTE.MATCH_ACCA_SLIP_SELECTION_BASE_INFO);
    const selectionContainerStyles = {
        ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_SELECTION_BG),
        borderColor: PALETTE.MATCH_ACCA_SLIP_SELECTION_BORDER_COLOR,
        borderStyle: 'solid',
        borderRadius: PALETTE.MATCH_ACCA_SLIP_SELECTION_BORDER_RADIUS,
        borderWidth: 1,
        boxShadow: PALETTE.MATCH_ACCA_SLIP_SELECTION_SHADOW,
    };
    const selectionLabelStyles = {
        ...selectionBaseInfo.eventName,
    };
    const selectionValueStyles = {
        ...selectionBaseInfo.selectionName,
    };

    return {
        MatchAccaSlipSelection: {
            style: {
                container: selectionContainerStyles,
                onboardingContainer: selectionContainerStyles,
                selectionInfo: {
                    label: selectionLabelStyles,
                    labelSuspended: selectionLabelStyles,
                    oddsValue: selectionValueStyles,
                    value: selectionValueStyles,
                    valueSuspended: selectionValueStyles,
                },
            },
            // should be reworked in MOJ-11246
            suspendedSign: {
                container: {
                    flexGrow: 0,
                    margin: '0 0 4px',
                },
                style: {
                    ...selectionBaseInfo.suspendedNotification,
                },
            },
            removeSelectionButton: {
                style: {
                    base: {
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        height: '100%',
                    },
                },
            },
            removeSelectionButtonIcon: {
                src: 'close',
                style: {
                    fill: PALETTE.MATCH_ACCA_SLIP_SELECTION_REMOVE_BUTTON.CLOSE_BUTTON_ICON_COLOR,
                    minHeight: 8,
                    minWidth: 8,
                },
            },
            separatorIcon: {
                style: {
                    fill: PALETTE.MATCH_ACCA_SLIP_SELECTION_SEPARATOR_ICON_COLOR,
                    minWidth: '24px',
                    minHeight: '24px',
                },
            },
        },
    };
}

function matchAccaSlipOnboardingFactory(PALETTE) {
    const {FONT} = PALETTE;

    const selectionLabelStyles = {
        fontSize: 11,
        ...PALETTE.MATCH_ACCA_SLIP_ONBOARDING_SELECTION_EVENT_NAME_TEXT,
    };
    const selectionValueStyles = {
        fontSize: FONT.SIZE_XXSMALL,
        fontWeight: 500,
        ...PALETTE.MATCH_ACCA_SLIP_ONBOARDING_SELECTION_NAME_TEXT,
    };

    return {
        MatchAccaSlipOnboardingView: {
            style: {
                container: {
                    ...resolveBackground(PALETTE.MATCH_ACCA_SLIP_ONBOARDING_BG),
                    fontSize: FONT.SIZE_MEDIUM,
                    _mobile_opacity: 0.9,
                    padding: '0px 16px',
                    _mobile_padding: '0px 16px',
                    textAlign: 'center',
                },
                callToAction: {
                    padding: 0,
                    margin: '24px 0 16px',
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    ...PALETTE.MATCH_ACCA_SLIP_ONBOARDING_TITLE_TEXT,
                },
                descriptionTitle: {
                    margin: 0,
                    fontSize: FONT.SIZE_SMALL,
                    ...PALETTE.MATCH_ACCA_SLIP_ONBOARDING_DESCRIPTION_HEADER_TEXT,
                },
                descriptionBody: {
                    margin: '8px 0 24px',
                    fontSize: FONT.SIZE_XSMALL,
                    ...PALETTE.MATCH_ACCA_SLIP_ONBOARDING_DESCRIPTION_BODY_TEXT,
                },
                selectionsContainer: {
                    margin: 0,
                },
            },
            addSelectionsButtonContainer: {
                style: {
                    padding: 0,
                    margin: '0 0 48px',
                },
            },
            addSelectionsButton: generatePrimaryButton(PALETTE.MATCH_ACCA_SLIP_ONBOARDING_START_BUTTON),
            matchAccaSlipSelection: {
                style: {
                    selectionInfo: {
                        label: selectionLabelStyles,
                        labelSuspended: selectionLabelStyles,
                        oddsValue: selectionValueStyles,
                        value: selectionValueStyles,
                        valueSuspended: selectionValueStyles,
                    },
                },
                separatorIcon: {
                    style: {
                        fill: PALETTE.MATCH_ACCA_SLIP_ONBOARDING_SELECTION_SEPARATOR_ICON_COLOR,
                        minWidth: '16px',
                        minHeight: '16px',
                    },
                },
            },
        },
    };
}
